import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MeterOperatorConst } from '@bo-client/activation-management/grid-registration/model/grid-registration.enum';

@Component({
  selector: 'app-meter-data',
  templateUrl: './meter-data.component.html',
  styleUrls: ['./meter-data.component.scss']
})
export class MeterDataComponent implements OnInit {
  @Input() inputForm: FormGroup;
  public meterOperatorConst = MeterOperatorConst;

  constructor() {}

  ngOnInit(): void {}
}
